<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="
          display: block;
          text-align: center;
          padding-bottom: 15px;
          font-size: 1.2em;
        "
        v-if="total > 0"
      >
        <span style="padding: 5px; float: left"
          >Total Records: <b>{{ total }}</b></span
        >
        <b-button
          class="download-button"
          variant="primary"
          size="lg"
          @click="downloadExcel()"
        >
          <LoadingCard v-if="loading2019" class="bouncing2"></LoadingCard>
          <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
          Download
        </b-button>
      </b-col>
      <b-col lg="12">
        <c-table :table-data="data" :fields="fields" :caption="title"></c-table>
        <LoadingCard v-show="loading"></LoadingCard>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import cTable from "./Table.vue";
Vue.component("downloadExcel", JsonExcel);

export default {
  props: ["type", "date_from", "date_to", "prodModel", "thirdPartyClientId"],
  components: { cTable, LoadingCard },
  data: () => {
    return {
      excelDownload: "",
      loading2019: false,
      dataType: "",
      loadingExcel: false,
      dateFromParam: "",
      dateToParam: "",
      selectedProductParam: "",
      selectedManufacturerParam: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "location", label: "Location" },
        { key: "originalRa", label: "Original RA" },
        { key: "fnsra", label: "New RA" },
        { key: "prodMake", label: "Make" },
        { key: "prodModel", label: "Model" },
        { key: "serNum", label: "Serial Number" },
        { key: "recvDate", label: "Received" },
        { key: "shipDate", label: "Shipped" },
        { key: "defChar", label: "Item Master#" },
        { key: "newSa", label: "NewSAP MM" },
      ],
    };
  },
  methods: {
    fetchData() {
      let params = {};
      params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.selectedProductParam,
        thirdPartyClientId: this.selectedManufacturerParam,
      };
      this.$http
        .get("api/comcast_portal/tables/alldata-" + this.dataType + ".php", {
          params,
        })
        .then(
          (res) => {
            this.data = res.data.records;
            if (res.data.message) {
              this.loading = false;
            }
            this.total = res.data.records.length;
            this.loading = false;
          },
          (err) => {
            this.loading = false;
            console.log(err);
          }
        );
    },
    downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        prodModel: this.selectedProductParam,
        thirdPartyClientId: this.selectedManufacturerParam,
        xml: "true",
      };
      this.$http
        .get("api/comcast_portal/tables/alldata-" + this.dataType + ".php", {
          params,
          responseType: "blob",
        })
        .then(
          (res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          (err) => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
  },
  mounted() {
    this.title = "Overall Data - " + this.type.toUpperCase();
    this.dateFromParam = this.date_from;
    this.dateToParam = this.date_to;
    (this.selectedProductParam = this.prodModel),
      (this.selectedManufacturerParam = this.thirdPartyClientId),
      (this.dataType = this.type);
    this.fetchData();
  },
};
</script>

<style>
.download-button {
  width: 150px;
  margin: auto;
  margin-left: 10px;
  float: right;
  font-weight: 500;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.bouncing2 {
  display: inline-block;
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  color: #ffffff68;
  padding-right: 0.5em;
}
</style>
